export const staleTime = 1000 * 60 * 5; // 5 minutes
